var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "_eui-multichart",
      class: {
        "-inaktiverad": _vm.skaVaraInaktiverad,
        "-osynlig": _vm.skaVaraOsynlig
      },
      attrs: { id: _vm.uniktId, disabled: _vm.skaVaraInaktiverad }
    },
    [
      _c("eui-highcharts", {
        attrs: { "vp-options": _vm.optionsForDiagrammetSomVisas },
        on: { "klickat-pa-highcharts": _vm.onKlickatPaHighcharts }
      }),
      _vm._v(" "),
      _c("eui-dialog", {
        attrs: {
          "vp-dialog-id": "andraInstallningar",
          "vp-huvud-text": "Ändra inställningar",
          "vp-bredd-med-enhet": "43rem",
          "vp-visa-dialogen": _vm.arIAndralage,
          "vp-dialog-stack": _vm.$root.dialogStack,
          "vp-dialog-config": _vm.andraDialogConfig
        },
        on: {
          "update:vpVisaDialogen": function($event) {
            _vm.arIAndralage = $event
          },
          "update:vp-visa-dialogen": function($event) {
            _vm.arIAndralage = $event
          },
          "knapp-tryckt-i-dialog": _vm.onKnappTrycktIAndraDialog,
          "avbryt-i-dialog": _vm.onAvbrytIAndraDialog
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var validationObserverMergedState =
                ref.validationObserverMergedState
              return [
                _c(
                  "form",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-wrap": "wrap",
                      margin: "-.9rem -2rem"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "inline-block",
                          padding: ".9rem 2rem",
                          width: "21rem"
                        }
                      },
                      [
                        _c("eui-form-radiogrupp", {
                          attrs: {
                            "vp-etikett": "Typ av diagram",
                            "vp-radiogrupp-config":
                              _vm.$_chartTypeRadiogruppConfig,
                            "vp-validation-rules": "required"
                          },
                          model: {
                            value: _vm.widgetSettings.ChartType,
                            callback: function($$v) {
                              _vm.$set(_vm.widgetSettings, "ChartType", $$v)
                            },
                            expression: "widgetSettings.ChartType"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "inline-block",
                          padding: ".9rem 2rem",
                          width: "21rem"
                        }
                      },
                      [
                        _c("eui-form-radiogrupp", {
                          attrs: {
                            "vp-etikett": "Omfattning",
                            "vp-radiogrupp-config":
                              _vm.$_chartPeriodRadiogruppConfig,
                            "vp-validation-rules": "required"
                          },
                          model: {
                            value: _vm.widgetSettings.ChartPeriod,
                            callback: function($$v) {
                              _vm.$set(_vm.widgetSettings, "ChartPeriod", $$v)
                            },
                            expression: "widgetSettings.ChartPeriod"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "inline-block",
                          padding: ".9rem 2rem",
                          width: "21rem"
                        }
                      },
                      [
                        _c("p", [_vm._v("\n\t\t\t\t\tVisa serier:\n\t\t\t\t")]),
                        _vm._v(" "),
                        _c("eui-form-kryssruta", {
                          attrs: {
                            "vp-etikett": "Utfall",
                            "vp-class": "-indragen",
                            "vp-style": "margin-top: .6em;"
                          },
                          model: {
                            value: _vm.widgetSettings.ShowCurrentYear,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.widgetSettings,
                                "ShowCurrentYear",
                                $$v
                              )
                            },
                            expression: "widgetSettings.ShowCurrentYear"
                          }
                        }),
                        _vm._v(" "),
                        _c("eui-form-kryssruta", {
                          attrs: {
                            "vp-etikett": "Föregående år",
                            "vp-class": "-indragen"
                          },
                          model: {
                            value: _vm.widgetSettings.ShowPreviousYear,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.widgetSettings,
                                "ShowPreviousYear",
                                $$v
                              )
                            },
                            expression: "widgetSettings.ShowPreviousYear"
                          }
                        }),
                        _vm._v(" "),
                        _vm.widgetSettings.BudgetCanExist
                          ? _c("eui-form-kryssruta", {
                              attrs: {
                                "vp-etikett": "Budget",
                                "vp-class": "-indragen"
                              },
                              model: {
                                value: _vm.widgetSettings.ShowBudget,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.widgetSettings,
                                    "ShowBudget",
                                    $$v
                                  )
                                },
                                expression: "widgetSettings.ShowBudget"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("eui-form-kryssruta", {
                          attrs: {
                            "vp-etikett": "Avvikelse mot föregående år",
                            "vp-class": "-indragen"
                          },
                          model: {
                            value:
                              _vm.widgetSettings.ShowDeviationFromPreviousYear,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.widgetSettings,
                                "ShowDeviationFromPreviousYear",
                                $$v
                              )
                            },
                            expression:
                              "widgetSettings.ShowDeviationFromPreviousYear"
                          }
                        }),
                        _vm._v(" "),
                        _vm.widgetSettings.BudgetCanExist
                          ? _c("eui-form-kryssruta", {
                              attrs: {
                                "vp-etikett": "Avvikelse mot budget",
                                "vp-inaktiverad": !_vm.widgetSettings
                                  .BudgetCanExist,
                                "vp-class": "-indragen"
                              },
                              model: {
                                value:
                                  _vm.widgetSettings.ShowDeviationFromBudget,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.widgetSettings,
                                    "ShowDeviationFromBudget",
                                    $$v
                                  )
                                },
                                expression:
                                  "widgetSettings.ShowDeviationFromBudget"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.vpForceNoLegend
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "inline-block",
                              padding: ".9rem 2rem",
                              width: "21rem"
                            }
                          },
                          [
                            _c("p", [_vm._v("\n\t\t\t\t\tÖvrigt:\n\t\t\t\t")]),
                            _vm._v(" "),
                            _c("eui-form-kryssruta", {
                              attrs: {
                                "vp-etikett":
                                  "Dölj diagramförklaringen<br>i små diagram",
                                "vp-hjalptext-html":
                                  "<p>En diagramförklaring visar vad diagrammets serier representerar (namn och färg).</p>",
                                "vp-class": "-indragen",
                                "vp-style": "margin-top: .6em;"
                              },
                              model: {
                                value:
                                  _vm.widgetSettings.HideLegendWhenChartIsSmall,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.widgetSettings,
                                    "HideLegendWhenChartIsSmall",
                                    $$v
                                  )
                                },
                                expression:
                                  "widgetSettings.HideLegendWhenChartIsSmall"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }